export const faqData = [
  {
    key: "1",
    QUESTION: "What are the requirements to rent a car?",
    ANSWER: "You must be at least 21 years old, have a vali...",
    CATEGORY: "Rental Policies",
    STATUS: "Published",
  },
  {
    key: "2",
    QUESTION: "Can I book a car without a credit card?",
    ANSWER: "Unfortunately, a credit card is required for bo...",
    CATEGORY: "Payments",
    STATUS: "Unpublish",
  },
  {
    key: "3",
    QUESTION: "Is insurance included in the rental price?",
    ANSWER: "Basic insurance is included. Additional cover...",
    CATEGORY: "Insurance",
    STATUS: "Published",
  },
  {
    key: "4",
    QUESTION: "What happens if I return the car late?",
    ANSWER: "Late returns incur a charge of $15 per hour. P...",
    CATEGORY: "Rental Policies",
    STATUS: "Published",
  },
  {
    key: "5",
    QUESTION: "Can I rent a car for a one-way trip?",
    ANSWER: "Yes, we offer one-way rentals. Additional fee...",
    CATEGORY: "Booking",
    STATUS: "Published",
  },
  {
    key: "6",
    QUESTION: "What documents do I need to rent a car?",
    ANSWER: "You need a valid driver’s license, a credit car...",
    CATEGORY: "Requirements",
    STATUS: "Published",
  },
  {
    key: "7",
    QUESTION: "How do I add an additional driver to my booking?",
    ANSWER: "You can add an additional driver when booki...",
    CATEGORY: "Drivers",
    STATUS: "Unpublish",
  },
  {
    key: "8",
    QUESTION: "What documents do I need to rent a car?",
    ANSWER: "You need a valid driver’s license, a credit car...",
    CATEGORY: "Drivers",
    STATUS: "Unpublish",
  },
  {
    key: "9",
    QUESTION: "Do you offer discounts for long-term rentals?",
    ANSWER: "Yes, we offer discounts for rentals longer tha...",
    CATEGORY: "Pricing",
    STATUS: "Published",
  },
  {
    key: "10",
    QUESTION: "What is the mileage policy for rentals?",
    ANSWER: "Unlimited mileage is offered on most cars, b...",
    CATEGORY: "Rental Policies",
    STATUS: "Published",
  },
  {
    key: "11",
    QUESTION: "What should I do if the car breaks down?",
    ANSWER: "Call our 24/7 roadside assistance number for...",
    CATEGORY: "Roadside Assistance",
    STATUS: "Published",
  },
];
